<div class="row-header" fxLayout="row" fxLayout.xs="column">
  <as-split direction="horizontal">
    <as-split-area size="30">
      <div fxLayout="column" fxLayout.xs="column">
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <h6 id="siteName-title">{{ siteName }}</h6>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row">
            <div class="col-sm-12">
              <button
                class="button-primary"
                id="collapse-realtime-tree"
                bciprimarybutton
                (click)="tree.treeControl.collapseAll()"
              >
                {{ 'energy.realTime.collapse' | translate }}
              </button>
              &nbsp;
              <button
                class="button-primary"
                id="expand-realtime-tree"
                bciprimarybutton
                (click)="tree.treeControl.expandAll()"
              >
                {{ 'energy.realTime.expand' | translate }}
              </button>
            </div>
          </div>
          <div class="row">
            <mat-tree
              #tree
              [dataSource]="dataSource"
              [(treeControl)]="treeControl"
            >
              <mat-tree-node
                [id]="node.title"
                class="site-mat-tree-node"
                *matTreeNodeDef="let node"
                matTreeNodeToggle
                matTreeNodePadding
                (click)="activeNode = node"
              >
                <button
                  id="node-title"
                  type="button"
                  (click)="$event.preventDefault()"
                  bciprimarybutton
                  disabled
                ></button>
                <mat-label
                  class="site-tree-node"
                  [ngClass]="{ 'site-node-actived': activeNode === node }"
                  (click)="featureLeafItemSelectionToggle(node)"
                  >{{ node.title }}</mat-label
                >
              </mat-tree-node>

              <mat-tree-node
                [id]="node.title"
                class="site-mat-tree-node"
                *matTreeNodeDef="let node; when: hasChild"
                matTreeNodePadding
              >
                <button
                  id="node-title"
                  type="button"
                  (click)="$event.preventDefault()"
                  bciprimarybutton
                  matTreeNodeToggle
                  [attr.aria-label]="'toggle ' + node.filename"
                >
                  <mat-icon
                    *ngIf="treeControl.isExpanded(node)"
                    fontIcon="Bosch-Ic-arrow-expand-down"
                  ></mat-icon>
                  <mat-icon
                    *ngIf="!treeControl.isExpanded(node)"
                    fontIcon="Bosch-Ic-arrow-expand-right"
                  ></mat-icon>
                </button>
                <mat-label
                  class="site-tree-node"
                  (click)="featureItemSelectionToggle(node)"
                  >{{ node.title }}</mat-label
                >
              </mat-tree-node>
            </mat-tree>
          </div>
        </mat-expansion-panel>
      </div>
    </as-split-area>
    <as-split-area size="70" style="overflow-y: hidden">
      <mat-expansion-panel [expanded]="true" class="realtime_graph_panel">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h6 id="power-consumed-title">
              {{ 'energy.realTime.powerConsum' | translate }}
            </h6>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div
          fxLayout="row"
          fxLayout.xs="column"
          style="align-items: center !important"
          class="site-layout"
        >
          <div
            fxFlex="80%;"
            fxFlex.xs="80%"
            fxLayout="column"
            fxLayout.xs="column"
          >
            <div style="margin: 1rem">
              <span class="selectdatelabel" id="select-date-range">{{
                'selectDateRange' | translate
              }}</span>
              <input
                class="datepicker"
                type="text"
                ngxDaterangepickerMd
                [(ngModel)]="dateRange"
                [showCustomRangeLabel]="true"
                [alwaysShowCalendars]="true"
                [ranges]="ranges"
                [linkedCalendars]="true"
                [showClearButton]="true"
                (ngModelChange)="onChangeDateRange()"
                (datesUpdated)="datesUpdated($event)"
                [locale]="{ format: 'YYYY-MM-DD' }"
              />
            </div>
          </div>
        </div>
        <div
          fxLayout="row"
          fxLayout.xs="column"
          [chart]="columnchart"
          style="width: 100%"
        ></div>
        <mat-action-row class="expansion-footer">
          <mat-label> &nbsp; {{ totalEnergy }}</mat-label>
        </mat-action-row>
      </mat-expansion-panel>
    </as-split-area>
  </as-split>
</div>
